const routes = {
  suppliers: 'Flotas'
};

export default routes;